import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/product/correct.svg'


const _withScopeId = n => (_pushScopeId("data-v-9e0bfc58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "solution_view" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "describe" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "asset" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thunbnail" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/L2A1_front.png",
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "introduce" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "label_description" }
const _hoisted_10 = { class: "options" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thunbnail" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/systemic_Liquid_cooling%20_renovation_solution.png",
    alt: ""
  })
], -1))
const _hoisted_13 = { class: "introduce" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "label_description" }
const _hoisted_16 = { class: "options" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thunbnail" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/rear_door_heat%20_exchange.png",
    alt: ""
  })
], -1))
const _hoisted_19 = { class: "introduce" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = {
  class: "label",
  style: {"margin-top":"-15px"}
}
const _hoisted_22 = { class: "label_description" }
const _hoisted_23 = { class: "options" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

import provide_key from "@/constant/provide_key";
import routerHash from "@/constant/router_hash";
import { inject, ref, onMounted, onUnmounted, onActivated } from "vue";
import Mitt from "@/utils/mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionView',
  setup(__props) {

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const airToLiquidCooling = ref<HTMLDivElement | null>(null);
const systemicLiquidCooling = ref<HTMLDivElement | null>(null);
const RDHxAirCooled = ref<HTMLDivElement | null>(null);

const onScroll = () => {
  const remToPx = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  const remValue = 49;
  const pxValue = remValue * remToPx;

  window.scrollTo({
    top: pxValue,
    behavior: "smooth",
  });
};

onMounted(() => {
  Mitt.on(routerHash.AIR_TO_LIQUID_COOLING, () =>
    airToLiquidCooling.value!.scrollIntoView(true)
  );
  Mitt.on(routerHash.SYSTEMIC_LIQUID_COOLING, () =>
    systemicLiquidCooling.value!.scrollIntoView(true)
  );
  Mitt.on(routerHash.RDHX_AIR_COOLED, () =>
    RDHxAirCooled.value!.scrollIntoView(true)
  );
});

onUnmounted(() => {
  Mitt.off(routerHash.AIR_TO_LIQUID_COOLING);
  Mitt.off(routerHash.SYSTEMIC_LIQUID_COOLING);
  Mitt.off(routerHash.RDHX_AIR_COOLED);
});

onActivated(() => window.scrollTo({ top: 0 }));

return (_ctx: any,_cache: any) => {
  const _directive_fadeIn = _resolveDirective("fadeIn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("solution.SOLUTION_DESCRIPTION")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("solution.SOLUTION_TITLE")), 1)
    ]),
    _createElementVNode("div", {
      class: "assets",
      ref_key: "airToLiquidCooling",
      ref: airToLiquidCooling
    }, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "asset_content",
          style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row-reverse' })
        }, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("solution.AIR_TO_LIQUID")), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("solution.AIR_TO_LIQUID_DESCRIPTION")), 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
                return _createElementVNode("div", {
                  class: "option",
                  key: index
                }, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`solution.AIR_TO_LIQUID_OPTIONS_${index}`)), 1)
                ])
              }), 64))
            ])
          ])
        ], 4)), [
          [_directive_fadeIn]
        ])
      ]),
      _createElementVNode("div", {
        class: "asset",
        ref_key: "systemicLiquidCooling",
        ref: systemicLiquidCooling
      }, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "asset_content",
          style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
        }, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("solution.LIQUID_TO_LIQUID")), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("solution.LIQUID_TO_LIQUID_DESCRIPTION")), 1),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
                return _createElementVNode("div", {
                  class: "option",
                  key: index
                }, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`solution.LIQUID_TO_LIQUID_OPTIONS_${index}`)), 1)
                ])
              }), 64))
            ])
          ])
        ], 4)), [
          [_directive_fadeIn]
        ])
      ], 512),
      _createElementVNode("div", {
        class: "asset",
        ref_key: "RDHxAirCooled",
        ref: RDHxAirCooled
      }, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "asset_content",
          style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row-reverse' })
        }, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("solution.LIQUID_TO_AIR_0")), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("solution.LIQUID_TO_AIR_1")), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("solution.LIQUID_TO_AIR_DESCRIPTION")), 1),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
                return _createElementVNode("div", {
                  class: "option",
                  key: index
                }, [
                  _hoisted_24,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`solution.LIQUID_TO_AIR_OPTIONS_${index}`)), 1)
                ])
              }), 64))
            ])
          ])
        ], 4)), [
          [_directive_fadeIn]
        ])
      ], 512)
    ], 512)
  ]))
}
}

})